import { useEffect, useState } from "react";
import { Grid, IconButton, MenuItem, Tooltip } from "@mui/material";
import { AddBox } from "@mui/icons-material";
import { t } from "i18next";
import api from "../../../../../../helpers/api/Api";
import ApiUrls from "../../../../../../helpers/urls/ApiUrls";
import SelectCustom from "../../../../../../components/SelectCustom";
import IPGroupModal from "./IPGroupModal";
import "./toIPGroup.css";

function ToIPGroup({ group, error, handleChange }) {
  const [ipGroups, setIPGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const userType = JSON.parse(localStorage.getItem("user")).type;

  useEffect(() => {
    getList();
  }, []);

  const getList = () => {
    setLoading(true);
    api.post(ApiUrls.ip_group.list, {})
      .then((response) => {
        setIPGroups(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }

  return (
    <>
      <Grid item md={3} xs={12} pl={{ md: 2, xs: 0 }} className="ip-group">
        <SelectCustom
          id="to-select"
          value={group}
          error={error}
          label={t("global.to")}
          onChange={handleChange}
          loading={loading}
        >
          {userType === 0 && <MenuItem value={"all"} key={"all"}>{t("global.all")}</MenuItem>}
          {ipGroups.map((ipg, i) => {
            return <MenuItem value={ipg.id} key={i}>{ipg.name}</MenuItem>
          })}
        </SelectCustom>

        <Tooltip placement="top"
                 title={t("button.plus", { item: t("report.ip_group") })}
        >
          <IconButton color="success" onClick={() => setModalOpen(true)}>
            <AddBox />
          </IconButton>
        </Tooltip>
      </Grid>

      <IPGroupModal
        ipGroups={ipGroups}
        setModalOpen={setModalOpen}
        modalOpen={modalOpen}
        getList={getList}
      />
    </>
  );
}

export default ToIPGroup;
